import axios from '../axios';

export const followUser = (data: BULLZ.UserFollowRequest) =>
    axios<BULLZ.MessageErrorResponseBase>({
        url: '/user/follow',
        data
    });
